







































































declare let bauminatorData:any;
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import "./_partners-map.less";
require("./partners.js");
import { translate } from "../../services/trans";

@Component({
  components: {
    
  }
})
export default class partnersMap extends Vue {
  private data: any = {
    System: [],
    loading: true,
    partnerTypes: [],
    isPager:false
  };


  mounted() {
    setTimeout(()=>{(window as any).onCreatedPartnersMap = true;document.body.click();},200)
    if(bauminatorData && bauminatorData.mapData && bauminatorData.mapData.partnerTypes){
      this.data.partnerTypes = bauminatorData.mapData.partnerTypes;
    }
    this.data.isPager = (window as any).bauminatorData && typeof (window as any).bauminatorData.showPartners != 'undefined' && (window as any).bauminatorData.showPartners == true;
  }
  created() {
    
  }

  trans(key:string) {
    return translate(key);
  }
}
